module.exports = __webpack_public_path__ + "img/place.216437d2.svg";